<form [formGroup]="beneficiary_fields_form">
  <h2>{{ "TRANSFERS.BENEFICIARY" | translate }}</h2>

  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <mat-form-field class="select-container w-full bg-neutral-100 " *ngFor="let field of product.beneficiary_fields">

      <mat-label class="w-full" *ngIf="field.name != 'residenceCountryISO'">{{ "TRANSFERS."+field.name | uppercase | translate }}:</mat-label>

      <div class="w-full flex flex-col items-start">
        <ng-container *ngIf="fixedTextPatterns.includes(field.regex) && extractOptionsFromPattern(field.regex).length > 0">

          <mat-select [formControlName]="field.name" class="p-2 rounded text-black">
            <mat-option *ngFor="let option of extractOptionsFromPattern(field.regex)" [value]="option">
              <div class="flex items-center">
                {{ "TRANSFERS."+option | translate }}
              </div>
            </mat-option>
          </mat-select>
        </ng-container>

        <ng-container *ngIf="field.name == 'region' && selRegion.length > 0" class="flex gap-3">
          <mat-select [formControlName]="field.name" class="p-2 rounded text-black">
            <mat-option *ngFor="let option of selRegion" [value]="option.code">
              <div class="flex items-center">
                {{ option.name | translate }}
              </div>
            </mat-option>
          </mat-select>
        </ng-container>

        <ng-container *ngIf="field.name == 'region' && selRegion.length == 0">
          <input matInput
                 [id]="field.name"
                 [formControlName]="field.name"
                 type="text" />
        </ng-container>

        <ng-container *ngIf="field.name == 'residenceCountryISO'">
          <div class="flex flex-row gap-3 items-center">
            <div><img [src]="'https://flagcdn.com/'+countryinfo?.countryCode?.toLowerCase()+'.svg'" width="50" class="flag-icon" /></div>
            <div>{{ countryinfo?.country }}</div>
          </div>
          <input matInput
                 [id]="field.name"
                 [formControlName]="field.name"
                 type="text"
                 [hidden]="true" />
        </ng-container>

        <ng-container *ngIf="(field.name !== 'residenceCountryISO' && field.name !== 'region' && (!fixedTextPatterns.includes(field.regex) || extractOptionsFromPattern(field.regex).length == 0))">
          <input matInput
                 [id]="field.name"
                 [formControlName]="field.name"
                 type="text" />
        </ng-container>

        <div *ngIf="beneficiary_fields_form.get(field.name)?.invalid && beneficiary_fields_form.get(field.name)?.touched">
          <small *ngIf="beneficiary_fields_form.get(field.name)?.value == ''" style="color:red;">{{ "COMMON.REQUIRED" | translate }}</small>
          <ng-container *ngIf="!fixedTextPatterns.includes(field.regex) && beneficiary_fields_form.get(field.name)?.value !== ''">
            <small style="color:red;" *ngIf="(!fixedTextPatterns.includes(field.regex) || extractOptionsFromPattern(field.regex).length == 0)">{{ "COMMON.INVALID" | translate }}{{field.regex}}</small>
          </ng-container>
        </div>

      </div>

    </mat-form-field>
  </div>
</form>


<form [formGroup]="account_types_form" *ngIf="product.account_types.length>0">
  <h2>{{ "TRANSFERS.ACCOUNT" | translate }}</h2>
  <ng-container *ngFor="let account of product.account_types">
    <ng-container *ngFor="let field of account.fields">
      
      <mat-form-field class="calls-full-width mb-4" *ngIf="field.name == 'zone'">
        <mat-label>{{ "TRANSFERS."+field.name | uppercase | translate }}:</mat-label>
        <div class="w-full flex flex-col items-start">
          <mat-select [formControlName]="field.name">
            <mat-option *ngFor="let zone of zones" [value]="replaceSpaces(zone.name)">
              {{ zone.name }}
            </mat-option>
          </mat-select>
          <div *ngIf="account_types_form.get(field.name)?.invalid && account_types_form.get(field.name)?.touched">
            <small *ngIf="account_types_form.get(field.name)?.value == ''" style="color:red;">{{ "COMMON.REQUIRED" | translate }}</small>
            <ng-container *ngIf="!fixedTextPatterns.includes(field.regex) && account_types_form.get(field.name)?.value !== ''">
              <small style="color:red;" *ngIf="(!fixedTextPatterns.includes(field.regex) || extractOptionsFromPattern(field.regex).length == 0)">{{ "COMMON.INVALID" | translate }}{{field.regex}}</small>
            </ng-container>
          </div>
        </div>
      </mat-form-field>
      
      <mat-form-field class="calls-full-width mb-4" *ngIf="field.name == 'area'" [hidden]="filteredAreas.length == 0">
        <mat-label>{{ "TRANSFERS."+field.name | uppercase | translate }}:</mat-label>
        <div class="w-full flex flex-col items-start">
          <mat-select [formControlName]="field.name">
            <mat-option *ngFor="let area of filteredAreas" [value]="replaceSpaces(area.name)">
              {{ area.name }}
            </mat-option>
          </mat-select>
          <div *ngIf="account_types_form.get(field.name)?.invalid && account_types_form.get(field.name)?.touched">
            <small *ngIf="account_types_form.get(field.name)?.value == ''" style="color:red;">{{ "COMMON.REQUIRED" | translate }}</small>
            <ng-container *ngIf="!fixedTextPatterns.includes(field.regex) && account_types_form.get(field.name)?.value !== ''">
              <small style="color:red;" *ngIf="(!fixedTextPatterns.includes(field.regex) || extractOptionsFromPattern(field.regex).length == 0)">{{ "COMMON.INVALID" | translate }}{{field.regex}}</small>
            </ng-container>
          </div>
        </div>
      </mat-form-field>

      <mat-form-field class="calls-full-width mb-4" *ngIf="field.name == 'municipality'" [hidden]="filteredMunicipalities.length == 0">
        <mat-label>{{ "TRANSFERS."+field.name | uppercase | translate }}:</mat-label>
        <div class="w-full flex flex-col items-start">
          <mat-select [formControlName]="field.name">
            <mat-option *ngFor="let municipality of filteredMunicipalities" [value]="replaceSpaces(municipality.name)">
              {{ municipality.name }}
            </mat-option>
          </mat-select>
          <div *ngIf="account_types_form.get(field.name)?.invalid && account_types_form.get(field.name)?.touched">
            <small *ngIf="account_types_form.get(field.name)?.value == ''" style="color:red;">{{ "COMMON.REQUIRED" | translate }}</small>
            <ng-container *ngIf="!fixedTextPatterns.includes(field.regex) && account_types_form.get(field.name)?.value !== ''">
              <small style="color:red;" *ngIf="(!fixedTextPatterns.includes(field.regex) || extractOptionsFromPattern(field.regex).length == 0)">{{ "COMMON.INVALID" | translate }}{{field.regex}}</small>
            </ng-container>
          </div>
        </div>
      </mat-form-field>

      <mat-form-field class="calls-full-width mb-4" *ngIf="field.name != 'zone' && field.name != 'area' && field.name != 'municipality'">
        <mat-label>{{ "TRANSFERS."+field.name | uppercase | translate }}:</mat-label>
        <div class="w-full flex flex-col items-start">
          <input matInput
                 [id]="field.name"
                 [formControlName]="field.name"
                 type="text" />
          <div *ngIf="account_types_form.get(field.name)?.invalid && account_types_form.get(field.name)?.touched">
            <small *ngIf="account_types_form.get(field.name)?.value == ''" style="color:red;">{{ "COMMON.REQUIRED" | translate }}</small>
            <ng-container *ngIf="!fixedTextPatterns.includes(field.regex) && account_types_form.get(field.name)?.value !== ''">
              <small style="color:red;" *ngIf="(!fixedTextPatterns.includes(field.regex) || extractOptionsFromPattern(field.regex).length == 0)">{{ "COMMON.INVALID" | translate }}{{field.regex}}</small>
            </ng-container>
          </div>
        </div>
      </mat-form-field>
              
    </ng-container>
  </ng-container>
</form>
